// Animation variables
export const SHORT_EXIT_DURATION = 0.05;

// Default animation transition to match the feel
// of the market web page. nilahealth.com
export const defaultAnimationTransition = {
  type: "spring",
  bounce: 0.2,
  visualDuration: 0.3,
} as const;

export const defaultAnimationTransitionWithDelay = (delay = 0.3) =>
  ({
    ...defaultAnimationTransition,
    delay,
  }) as const;

export const defaultAnimationStaggerTransition = (
  index: number,
  delay = 0.06
) => defaultAnimationTransitionWithDelay(index * delay);

// Animation variants to be reused
export const fadeWithBlur = {
  animate: { opacity: 1, scale: 1, filter: "blur(0px)" },
  exit: {
    opacity: 0,
    scale: 0.95,
    filter: "blur(4px)",
    transition: { duration: SHORT_EXIT_DURATION },
  },
  initial: { opacity: 0, scale: 0.95, filter: "blur(4px)" },
} as const;

// Animation variants used in ProcessingIndicator
export const fadeInUp = {
  hidden: { opacity: 0, y: 10 },
  visible: {
    opacity: 1,
    y: 0,
    transition: defaultAnimationTransitionWithDelay(),
  },
} as const;

export const fadeInLeft = {
  hidden: { opacity: 0, x: -5 },
  visible: {
    opacity: 1,
    x: 0,
    transition: defaultAnimationTransition,
  },
} as const;

// Tab transitions
export const tabTriggerTransition = {
  type: "spring",
  stiffness: 500,
  damping: 40,
  mass: 0.6,
} as const;

export const tabBackgroundTransition = {
  type: "spring",
  stiffness: 500,
  damping: 40,
} as const;

// Expand/collapse content animation for onboarding widget
export const CONTENT_GAP = 2;

export const onboardingExpandCollapseVariants = {
  expanded: {
    height: "auto",
    marginTop: CONTENT_GAP,
    opacity: 1,
    transition: { ...defaultAnimationTransition, delay: 0.15 },
  },
  collapsed: {
    height: 0,
    marginTop: 0,
    opacity: 0,
    transition: defaultAnimationTransition,
  },
} as const;

// Onboarding timing constants
export const ONBOARDING_COMPLETION_DELAY_MS = 800;
export const ONBOARDING_CELEBRATION_DELAY_MS = 1000;
export const ONBOARDING_CELEBRATION_DISPLAY_MS = 2000;
